const ProductList = () => import('../../pages/products/ProductList');

export default [
  // Choco Shake
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-choco-shake',
    name: 'choco-shake-stamps',
    component: ProductList,
    props: {
      title: 'Set de tampons alphabet Choco Shake',
      description:
        "Personnalise tes créations ultra facilement avec le set de tampons alphabet Choco Shake ! <br/> Avec ses lettres rondes et gourmandes, la police d'écriture Choco Shake est à la fois ludique et moderne.",
      tags: ['set-tampon-alphabet-choco-shake'],
      articles: [
        {
          src: require('../../../public/img/materiel-creatif/choco-shake/set-complet-choco-shake.jpg'),
          name: 'Choco Shake',
          variant: 'Set complet',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-choco-shake/set-complet-choco-shake',
          highlight: true,
        },
        {
          src: require('../../../public/img/materiel-creatif/choco-shake/choco-shake-majuscules.jpg'),
          name: 'Choco Shake',
          variant: 'Jeu de majuscules',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-choco-shake/majuscules-choco-shake',
        },
        {
          src: require('../../../public/img/materiel-creatif/choco-shake/choco-shake-minuscules.jpg'),
          name: 'Choco Shake',
          variant: 'Jeu de minuscules',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-choco-shake/minuscules-choco-shake',
        },
        {
          src: require('../../../public/img/materiel-creatif/choco-shake/choco-shake-speciaux.jpg'),
          name: 'Choco Shake',
          variant: 'Caractères spéciaux & Chiffres',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-choco-shake/speciaux-chiffres-choco-shake',
        },
        {
          src: require('../../../public/img/materiel-creatif/accessoires/vignette-accessoires.jpg'),
          name: '',
          variant: 'Accessoires',
          link:
            '/produit/materiel-creatif/set-tampon-alphabet/accessoires',
        },
      ],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-choco-shake/set-complet-choco-shake',
    name: 'full-set-choco-shake',
    component: () =>
      import('../../pages/products/creative/ChocoShake/FullSet'),
    props: {
      src: require('../../../public/img/materiel-creatif/choco-shake/set-complet-choco-shake.jpg'),
      type: 'Set complet Choco Shake',
      hiddenType: 'choco-shake-stamps',
      description:
        'Un set complet se compose d’1 jeu de majuscules, 1 jeu de minuscules et 1 jeu de caractères spéciaux et chiffres.<br />Entre 110 et 125 caractères accompagnés de leurs plateaux de rangement.<br />Plusieurs lettres sont déjà en double mais n’hésite pas à doubler tout le jeu de minuscules et/ou majuscules pour obtenir un set ultra complet.<br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-choco-shake'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-choco-shake/majuscules-choco-shake',
    name: 'uppercase-choco-shake',
    component: () =>
      import('../../pages/products/creative/ChocoShake/Uppercase'),
    props: {
      src: require('../../../public/img/materiel-creatif/choco-shake/choco-shake-majuscules.jpg'),
      type: 'Jeu de majuscules Choco Shake',
      hiddenType: 'choco-shake-stamps',
      description:
        'Un jeu de majuscules comporte plusieurs caractères en double pour un total de 41 caractères.<br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-choco-shake'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-choco-shake/minuscules-choco-shake',
    name: 'lowercase-choco-shake',
    component: () =>
      import('../../pages/products/creative/ChocoShake/Lowercase'),
    props: {
      src: require('../../../public/img/materiel-creatif/choco-shake/choco-shake-minuscules.jpg'),
      type: 'Jeu de minuscules Choco Shake',
      hiddenType: 'choco-shake-stamps',
      description:
        "Un jeu de minuscules comporte plusieurs caractères en double pour un total de 41 caractères.<br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.",
      tags: ['set-tampon-alphabet-choco-shake'],
    },
  },
  {
    path:
      '/produit/materiel-creatif/set-tampon-alphabet/set-tampon-alphabet-choco-shake/speciaux-chiffres-choco-shake',
    name: 'specials-numbers-choco-shake',
    component: () =>
      import('../../pages/products/creative/ChocoShake/Special'),
    props: {
      src: require('../../../public/img/materiel-creatif/choco-shake/choco-shake-speciaux.jpg'),
      type: 'Caractères spéciaux et chiffres Choco Shake',
      hiddenType: 'choco-shake-stamps',
      description:
        'Un jeu de caractères spéciaux et chiffres comporte : 11 caractères accentués, 11 éléments de ponctuation, 2x les chiffres de 0 à 9 et même un petit cœur. <br />Le plateau de rangement te permet d’organiser, de composer ou compléter ton coffret de tampons alphabet Widddi. <br />Retrouve plus d’infos dans la description ci-dessous.',
      tags: ['set-tampon-alphabet-choco-shake'],
    },
  },
];
